export function formatMilliseconds(milliseconds: number): string {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const fraction = milliseconds % 1000;

  const padTo2Digits = (num: number) => num.toString().padStart(2, '0');
  const padTo3Digits = (num: number) => num.toString().padStart(3, '0');

  return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}:${padTo3Digits(fraction)}`;
}

export function formatDateToLocal(dateString: string): string {
  // Treat timestamps without timezone as UTC to avoid JS assuming local
  const isOffsetSpecified = /[zZ]|[+-]\d{2}:?\d{2}$/.test(dateString);
  const normalized = isOffsetSpecified ? dateString : `${dateString}Z`;
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return dateString;
  return d.toLocaleString();
}

export function formatDateOnlyLocal(dateString: string): string {
  const isOffsetSpecified = /[zZ]|[+-]\d{2}:?\d{2}$/.test(dateString);
  const normalized = isOffsetSpecified ? dateString : `${dateString}Z`;
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return dateString;
  return d.toLocaleDateString();
}

export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Helper function to get next hour with 00 minutes as default time for datetime-local picker
export const getDefaultTimePickerDateTime = (): string => {
  const now = new Date();
  const nextHour = new Date(now);
  nextHour.setHours(now.getHours() + 1, 0, 0, 0);
  const hours = String(nextHour.getHours()).padStart(2, '0');
  return `${formatLocalDate(nextHour)}T${hours}:00`;
};


